module.exports = __webpack_public_path__ + "img/cars_quote.ddd2ff99.png";